<template>
    <AppLayout title="Editar Envio Pendiente">
        <Toast />
        <Breadcrumb route="envios_multiple" page="Editar Envio Pendiente" />
        <form class="p-2">
            <div class="bg-white rounded-lg shadow-md p-5 m-2 lg:mx-4">
                <div v-if="form.errores !== null">
                    <div class="relative z-0">
                        <input type="text" id="errores" v-model="form.errores" aria-describedby="standard_error_help" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-red-600 appearance-none dark:text-white dark:border-red-500 dark:focus:border-red-500 focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                        <label for="errores" class="absolute text-sm text-red-600 dark:text-red-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Error</label>
                    </div>
                    <br>
                </div>
                <div class="font-medium text-gray-600 text-xl mb-4">
                    Datos
                </div>
                <div class="flex flex-col">
                    <div class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2">
                        <div class="w-full h-24">
                            <label for="num_orden" class="my-1 text-gray-700">
                                N° de Orden<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="num_orden"
                                :class="[
                                    't-input',
                                    form.errors.num_orden && 't-input-invalid',
                                ]"
                                v-model="form.num_orden"
                                placeholder="ej. Romina Campos"
                            />
                            <small
                                v-if="form.errors.num_orden"
                                id="num_orden-help"
                                class="p-error"
                            >
                                {{ form.errors.num_orden }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label for="destinatario" class="my-1 text-gray-700">
                                Nombre<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="destinatario"
                                :class="[
                                    't-input',
                                    form.errors.destinatario && 't-input-invalid',
                                ]"
                                v-model="form.destinatario"
                                placeholder="ej. Romina Campos"
                            />
                            <small
                                v-if="form.errors.destinatario"
                                id="destinatario-help"
                                class="p-error"
                            >
                                {{ form.errors.destinatario }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label
                                for="num_documento"
                                class="my-1 text-gray-700"
                            >
                                Nro. documento<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="num_documento"
                                :class="[
                                    't-input',
                                    form.errors.num_documento && 't-input-invalid',
                                ]"
                                v-model="form.num_documento"
                                placeholder="ej. 99999999"
                            />
                            <small
                                v-if="form.errors.num_documento"
                                id="num_documento-help"
                                class="p-error"
                            >
                                {{ form.errors.num_documento }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label for="email" class="my-1 text-gray-700">
                                Email<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="email"
                                id="email"
                                :class="[
                                    't-input',
                                    form.errors.email && 't-input-invalid',
                                ]"
                                v-model="form.email"
                                placeholder="ej. romina.campos75@gmail.com"
                            />
                            <small
                                v-if="form.errors.email"
                                id="email-help"
                                class="p-error"
                            >
                                {{ form.errors.email }}
                            </small>
                        </div>
                    </div>
                    <div class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2">
                        <div class="w-full h-24">
                            <label
                                for="telefono"
                                class="my-1 text-gray-700"
                            >
                                Telefono<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="tel"
                                id="telefono"
                                :class="[
                                    't-input',
                                    form.errors.telefono && 't-input-invalid',
                                ]"
                                v-model="form.telefono"
                                placeholder="ej. +54 11 1234-5678"
                            />
                            <small
                                v-if="form.errors.telefono"
                                id="telefono-help"
                                class="p-error"
                            >
                                {{ form.errors.telefono }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label for="calle" class="my-1 text-gray-700">
                                Calle<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="calle"
                                :class="[
                                    't-input',
                                    form.errors.calle && 't-input-invalid',
                                ]"
                                v-model="form.calle"
                                placeholder="ej. Av. San Martín"
                            />
                            <small
                                v-if="form.errors.calle"
                                id="calle-help"
                                class="p-error"
                            >
                                {{ form.errors.calle }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label for="altura" class="my-1 text-gray-700">
                                Altura<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="altura"
                                :class="[
                                    't-input',
                                    form.errors.altura && 't-input-invalid',
                                ]"
                                v-model="form.altura"
                                placeholder="ej. 4864"
                            />
                            <small
                                v-if="form.errors.altura"
                                id="altura-help"
                                class="p-error"
                            >
                                {{ form.errors.altura }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label for="piso" class="my-1 text-gray-700">
                                Piso
                            </label>
                            <input
                                type="text"
                                id="piso"
                                :class="[
                                    't-input',
                                    form.errors.piso && 't-input-invalid',
                                ]"
                                v-model="form.piso"
                                placeholder="ej. 4"
                            />
                            <small
                                v-if="form.errors.piso"
                                id="piso-help"
                                class="p-error"
                            >
                                {{ form.errors.piso }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label for="dpto" class="my-1 text-gray-700">
                                Dpto.
                            </label>
                            <input
                                type="text"
                                id="dpto"
                                :class="[
                                    't-input',
                                    form.errors.dpto && 't-input-invalid',
                                ]"
                                v-model="form.dpto"
                                placeholder="ej. Centro"
                            />
                            <small
                                v-if="form.errors.dpto"
                                id="dpto-help"
                                class="p-error"
                            >
                                {{ form.errors.dpto }}
                            </small>
                        </div>
                    </div>
                    <div class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2">
                        <div class="w-full h-24">
                            <label for="cp" class="my-1 text-gray-700">
                                Código Postal<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="cp"
                                :class="[
                                    't-input',
                                    form.errors.cp && 't-input-invalid',
                                ]"
                                v-model="form.cp"
                                placeholder="ej. 6000"
                            />
                            <small
                                v-if="form.errors.cp"
                                id="cp-help"
                                class="p-error"
                            >
                                {{ form.errors.cp }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label
                                for="localidad"
                                class="my-1 text-gray-700"
                            >
                                Localidad<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="localidad"
                                :class="[
                                    't-input',
                                    form.errors.localidad && 't-input-invalid',
                                ]"
                                v-model="form.localidad"
                                placeholder="ej. Junín"
                            />
                            <small
                                v-if="form.errors.localidad"
                                id="localidad-help"
                                class="p-error"
                            >
                                {{ form.errors.localidad }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label
                                for="provincia"
                                class="my-1 text-gray-700"
                            >
                                Provincia<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="provincia"
                                :class="[
                                    't-input',
                                    form.errors.provincia && 't-input-invalid',
                                ]"
                                v-model="form.provincia"
                                placeholder="ej. Buenos Aires"
                            />
                            <small
                                v-if="form.errors.provincia"
                                id="provincia-help"
                                class="p-error"
                            >
                                {{ form.errors.provincia }}
                            </small>
                        </div>
                        <div class="w-full h-24">
                            <label for="observacion" class="my-1 text-gray-700">
                                Observación
                            </label>
                            <input
                                type="text"
                                id="observacion"
                                :class="[
                                    't-input',
                                    form.errors.observacion && 't-input-invalid',
                                ]"
                                v-model="form.observacion"
                            />
                            <small
                                v-if="form.errors.observacion"
                                id="observacion-help"
                                class="p-error"
                            >
                                {{ form.errors.observacion }}
                            </small>
                    </div>
                </div>
                </div>
            </div>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="update">Editar Envio Pendiente</Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: ["envio"],
    data() {
        return {
            prueba: JSON.parse(this.$props.envio.destino),
            form: this.$inertia.form({
                num_orden: this.$props.envio.num_orden,
                errores: this.$props.envio.errores,
                destinatario : "",
                num_documento: "", 
                telefono: "", 
                email: "",
                cp: "",
                calle: "",
                altura: "",
                piso: "", 
                dpto: "", 
                localidad: "",
                provincia: "",
                observacion: "", 

            }),
        };
    },
    methods: {
        update() {
            //this.form.put("/envios/" + this.envio.id);
            this.form.put("/envios/" + this.envio.id, {
                onSuccess: () => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Exito",
                        detail: "Envio Actualizado",
                        life: 3000,
                    });
                },
            });
        }
    },
    created(){
        this.form.destinatario = this.prueba.destinatario;
        this.form.num_documento = this.prueba.numero_documento;
        this.form.telefono = this.prueba.telefono;
        this.form.email = this.prueba.email;
        this.form.cp = this.prueba.cp;
        this.form.calle = this.prueba.calle;
        this.form.altura = this.prueba.altura;
        this.form.piso = this.prueba.piso;
        this.form.dpto = this.prueba.dpto;
        this.form.localidad = this.prueba.localidad;
        this.form.provincia = this.prueba.provincia;
        this.form.observacion = this.prueba.observacion;
    }
    
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>